import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Search, RotateCcw, Users, Sparkles } from "lucide-react";

const ANY = "__any";

export default function VoiceFilters({ filters, values, onChange, onReset, hideTypeToggle }) {
  const set = (k) => (v) => onChange({ ...values, [k]: v === ANY ? "" : v });
  const ageOptions = ["6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"];

  return (
    <div className="rounded-2xl border border-zinc-200 bg-white p-4 md:p-5">
      <div className="flex flex-col gap-3">
        <div className="relative">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
          <Input data-testid="voice-search-input" placeholder="Search voices by name…"
            value={values.q || ""} onChange={(e) => onChange({ ...values, q: e.target.value })}
            className="pl-10 rounded-xl h-11" />
        </div>

        {!hideTypeToggle && (
        <div className="flex rounded-full bg-zinc-100 p-1 text-sm font-semibold">
          {[["", "All", null], ["human", "Human", Users], ["ai", "AI", Sparkles]].map(([val, label, Icon]) => (
            <button key={label} data-testid={`filter-type-${label.toLowerCase()}`}
              onClick={() => onChange({ ...values, voice_type: val })}
              className={`flex flex-1 items-center justify-center gap-1.5 rounded-full py-2 transition ${
                (values.voice_type || "") === val ? "bg-white text-brand-violet shadow-sm" : "text-zinc-500"}`}>
              {Icon && <Icon size={14} />} {label}
            </button>
          ))}
        </div>
        )}

        <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
          <FilterSelect testid="filter-language" label="Language" value={values.language}
            onChange={set("language")} options={filters.languages || []} />
          <FilterSelect testid="filter-country" label="Country" value={values.country}
            onChange={set("country")} options={filters.countries || []} />
          <div>
            <label className="label-eyebrow text-zinc-400 mb-1 block">Gender</label>
            <Select value={values.gender || ANY} onValueChange={set("gender")}>
              <SelectTrigger data-testid="filter-gender" className="rounded-xl h-11"><SelectValue placeholder="Any" /></SelectTrigger>
              <SelectContent>
                <SelectItem value={ANY}>Any</SelectItem>
                <SelectItem value="male">Boy</SelectItem>
                <SelectItem value="female">Girl</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="label-eyebrow text-zinc-400 mb-1 block">Voice age</label>
            <Select value={values.age || ANY} onValueChange={set("age")}>
              <SelectTrigger data-testid="filter-age" className="rounded-xl h-11"><SelectValue placeholder="Any" /></SelectTrigger>
              <SelectContent>
                <SelectItem value={ANY}>Any</SelectItem>
                {ageOptions.map((a) => <SelectItem key={a} value={a}>{a} years</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>

        <button onClick={onReset} data-testid="reset-filters"
          className="mt-1 inline-flex items-center gap-2 self-start text-sm font-semibold text-zinc-500 hover:text-brand-violet">
          <RotateCcw size={14} /> Reset filters
        </button>
      </div>
    </div>
  );
}

function FilterSelect({ testid, label, value, onChange, options }) {
  return (
    <div>
      <label className="label-eyebrow text-zinc-400 mb-1 block">{label}</label>
      <Select value={value || ANY} onValueChange={onChange}>
        <SelectTrigger data-testid={testid} className="rounded-xl h-11"><SelectValue placeholder="Any" /></SelectTrigger>
        <SelectContent>
          <SelectItem value={ANY}>Any</SelectItem>
          {options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
